export default {
  jurisdiction_building_estimates: [],
  custom_building_estimates: [],
  type_prototypes: [],
  is_updating : false,
}